module.exports = __webpack_public_path__ + "img/forbes-head.4efcc515.svg";